// ====================================== Scrollling Text
$(document).ready(function () {
  var containers = $(".containerr");

  if (containers.length) {
    containers.each(function () {
      var container = $(this);

      // Support small text - copy to fill screen width
      if (container.find(".scrolling-text").outerWidth() < $(window).width()) {
        var windowToScrolltextRatio = Math.round(
            $(window).width() / container.find(".scrolling-text").outerWidth()
          ),
          scrollTextContent = container
            .find(".scrolling-text .scrolling-text-content")
            .text(),
          newScrollText = "";
        for (var i = 0; i < windowToScrolltextRatio; i++) {
          newScrollText += " " + scrollTextContent;
        }
        container
          .find(".scrolling-text .scrolling-text-content")
          .text(newScrollText);
      }

      // Init variables and config
      var scrollingText = container.find(".scrolling-text"),
        scrollingTextWidth = scrollingText.outerWidth(),
        scrollingTextHeight = scrollingText.outerHeight(true),
        startLetterIndent =
          parseInt(
            scrollingText.find(".scrolling-text-content").css("font-size"),
            10
          ) / 4.8,
        startLetterIndent = Math.round(startLetterIndent),
        scrollAmountBoundary = Math.abs($(window).width() - scrollingTextWidth),
        transformAmount = 0,
        leftBound = 0,
        rightBound = scrollAmountBoundary,
        transformDirection = container.hasClass("left-to-right") ? -1 : 1,
        transformSpeed = 200;

      // Read transform speed
      if (container.attr("speed")) {
        transformSpeed = container.attr("speed");
      }

      // Make scrolling text copy for scrolling infinity
      container.append(scrollingText.clone().addClass("scrolling-text-copy"));
      container.find(".scrolling-text").css({ position: "absolute", left: 0 });
      container.css("height", scrollingTextHeight);

      var getActiveScrollingText = function (direction) {
        var firstScrollingText = container.find(".scrolling-text:nth-child(1)");
        var secondScrollingText = container.find(
          ".scrolling-text:nth-child(2)"
        );

        var firstScrollingTextLeft = parseInt(
          container.find(".scrolling-text:nth-child(1)").css("left"),
          10
        );
        var secondScrollingTextLeft = parseInt(
          container.find(".scrolling-text:nth-child(2)").css("left"),
          10
        );

        if (direction === "left") {
          return firstScrollingTextLeft < secondScrollingTextLeft
            ? secondScrollingText
            : firstScrollingText;
        } else if (direction === "right") {
          return firstScrollingTextLeft > secondScrollingTextLeft
            ? secondScrollingText
            : firstScrollingText;
        }
      };

      $(window).on("wheel", function (e) {
        var delta = e.originalEvent.deltaY;

        if (delta > 0) {
          // going down
          if (transformAmount < rightBound) {
            transformAmount += transformSpeed * transformDirection;
            container
              .find(".scrolling-text .scrolling-text-content")
              .css("transform", "skewX(10deg)");
          }
        } else {
          if (transformAmount > leftBound) {
            transformAmount -= transformSpeed * transformDirection;
            container
              .find(".scrolling-text .scrolling-text-content")
              .css("transform", "skewX(-10deg)");
          }
        }

        setTimeout(function () {
          container
            .find(".scrolling-text")
            .css(
              "transform",
              "translate3d(" + transformAmount * -1 + "px, 0, 0)"
            );
        }, 10);

        setTimeout(function () {
          container
            .find(".scrolling-text .scrolling-text-content")
            .css("transform", "skewX(0)");
        }, 500);

        // Boundaries
        if (transformAmount < leftBound) {
          var activeText = getActiveScrollingText("left");
          activeText.css({
            left:
              Math.round(leftBound - scrollingTextWidth - startLetterIndent) +
              "px",
          });
          leftBound = parseInt(activeText.css("left"), 10);
          rightBound =
            leftBound +
            scrollingTextWidth +
            scrollAmountBoundary +
            startLetterIndent;
        } else if (transformAmount > rightBound) {
          var activeText = getActiveScrollingText("right");
          activeText.css({
            left:
              Math.round(
                rightBound +
                  scrollingTextWidth -
                  scrollAmountBoundary +
                  startLetterIndent
              ) + "px",
          });
          rightBound += scrollingTextWidth + startLetterIndent;
          leftBound =
            rightBound -
            scrollingTextWidth -
            scrollAmountBoundary -
            startLetterIndent;
        }
      });
    });
  }
});

//==================== Footer Js

$(document).ready(function () {
  $(".footer_title1").click(function () {
    if ($(window).width() <= 767) {
      $(this)
        .parent()
        .toggleClass("active")
        .find(".footer_menu_wrap1")
        .slideToggle();
      $(this)
        .parent()
        .siblings()
        .removeClass("active")
        .find(".footer_menu_wrap1")
        .slideUp();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all tab headers and content sections
  const tabHeadersUpdated = document.querySelectorAll(
    ".collections_tabify__titleeeee"
  );
  const tabContents = document.querySelectorAll(".product_tab_details");

  // Function to handle tab switching
  function switchTab(event) {
    const targetId = event.target.getAttribute("data-tab-title");

    // Hide all tab contents and remove active class from all tab headers
    tabContents.forEach((content) => content.classList.remove("active"));
    tabHeadersUpdated.forEach((header) => header.classList.remove("active"));

    // Show the clicked tab's content and add active class to clicked tab header
    const targetContent = document.getElementById(targetId);
    if (targetContent) {
      targetContent.classList.add("active");
    }
    event.target.classList.add("active");
  }

  // Add click event listeners to all tab headers
  tabHeadersUpdated.forEach((header) =>
    header.addEventListener("click", switchTab)
  );

  // Activate the first tab by default
  if (tabHeadersUpdated.length > 0) {
    tabHeadersUpdated[0].classList.add("active");
    const firstTabId = tabHeadersUpdated[0].getAttribute("data-tab-title");
    const firstTabContent = document.getElementById(firstTabId);
    if (firstTabContent) {
      firstTabContent.classList.add("active");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all tab headers and content sections
  const tabHeaders = document.querySelectorAll(".collections_tabify__title");
  const tabContents = document.querySelectorAll(".product_tab_details");
  const mobileTitles = document.querySelectorAll(
    ".collections_tabify__main_title.mobile_title"
  );

  // Function to handle tab switching
  function switchTab(event) {
    const targetId = event.target.getAttribute("data-tab-title");

    // Hide all tab contents and remove active class from all tab headers
    tabContents.forEach((content) => content.classList.remove("active"));
    tabHeaders.forEach((header) => header.classList.remove("active"));

    // Show the clicked tab's content and add active class to clicked tab header
    document.getElementById(targetId).classList.add("active");
    event.target.classList.add("active");
  }

  // Add click event listeners to all tab headers
  tabHeaders.forEach((header) => header.addEventListener("click", switchTab));

  // Activate the first tab by default
  if (tabHeaders.length > 0) {
    tabHeaders[0].classList.add("active");
    const firstTabId = tabHeaders[0].getAttribute("data-tab-title");
    document.getElementById(firstTabId).classList.add("active");
  }

  // Add click event listeners to mobile titles
  mobileTitles.forEach(function (title) {
    title.addEventListener("click", function () {
      var tabIndex = this.getAttribute("data-tab-index");

      // Remove 'active' class from all mobile titles and product tabs
      mobileTitles.forEach((title) => title.classList.remove("active"));
      document
        .querySelectorAll(".product-tab")
        .forEach((tab) => tab.classList.remove("active"));

      // Add 'active' class to the clicked mobile title and corresponding product tab
      this.classList.add("active");
      var correspondingTab = document.querySelector(
        '.product-tab[data-tab-index="' + tabIndex + '"]'
      );
      if (correspondingTab) {
        correspondingTab.classList.add("active");
      }
    });
  });
});